import { QuestionAnswers } from '__generated__/api';
import { AnswerViewModel, UserQuestionViewModel } from 'models/hotel';

export const mapUserQuestion = (question: QuestionAnswers.Questions): UserQuestionViewModel => ({
  questionId: question.id,
  questionSubmissionTime: question.createDate.formatted,
  questionText: question.question,
  questioner: question.questioner,
  answers: question.answers.map(mapUserAnswer),
  totalAnswersCount: question.totalAnswers.raw
});

const mapUserAnswer = (answer: QuestionAnswers.Answers): AnswerViewModel => ({
  answerId: answer.id,
  answerText: answer.answer,
  answerSubmissionTime: answer.answerTime.formatted,
  userDisplayName: answer.displayName,
  totalUpVotes: answer.upVotes.raw
});
